export default (id) => `/expert/${id}`;
